// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep ag-grid-angular {
  width: 100% !important;
  display: block;
}

::ng-deep .ag-root-wrapper {
  width: 100% !important;
}

::ng-deep .ag-theme-quartz {
  width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/device-table/device-table.component.scss"],"names":[],"mappings":"AAEA;EACE,sBAAA;EACA,cAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,sBAAA;AADF","sourcesContent":["// Empty file for now, using global styles\n\n::ng-deep ag-grid-angular {\n  width: 100% !important;\n  display: block;\n}\n\n::ng-deep .ag-root-wrapper {\n  width: 100% !important;\n}\n\n::ng-deep .ag-theme-quartz {\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
